import { render } from "./maskLayer.vue?vue&type=template&id=46977096&lang=pug"
import script from "./maskLayer.vue?vue&type=script&setup=true&lang=js"
export * from "./maskLayer.vue?vue&type=script&setup=true&lang=js"

import "./maskLayer.vue?vue&type=style&index=0&id=46977096&lang=css"

import exportComponent from "/Users/liu/Downloads/开发程序/bridge v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__